/**
 * AI:
 * Status: 'in progress'
 * Type: Component
 * SubType: ObjectBaseComponent
 * Reason: Object component for lg.LogicMappingTable — loads the table and dispatches to the full or the
 *         side view. Registered in lg.entity-provider.ts for mode 'update'.
 */
import {Component, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {ConfirmationService} from 'primeng/api';
import {ObjectBaseComponent} from '../../../../../core/shared/object/mvs-object-base/object-base.component';
import {MvsCoreService} from '../../../../../core/shared/service/mvs-core.service';
import {MvsMessageService} from '../../../../../core/shared/service/message/mvs-message.service';
import {ObserverService} from '../../../../../core/shared/object/service/observer.service';
import {LogicMappingTableDto} from '../../../model/dto/entity/logic-mapping-table.dto';

/**
 * Object component for `lg.LogicMappingTable`.
 *
 * Reached from two places: the row click on the Wertetabellen section of the LG config page, which
 * navigates to the object page `lg/mapping-table/:id`, and the right-hand drawer, which resolves this
 * component through the entity provider for mode `update`.
 *
 * <h2>Why it is registered for mode `update` only</h2>
 * A mode-less registry entry matches EVERY mode, `create` included. Creating a mapping table would then
 * render this component for a row that does not exist yet — the load fails and the dialog stays empty.
 * With the entry bound to `update`, creation falls through to the generic metadata form, which is the
 * correct surface for it. The object page resolves the component through its own override rather than
 * relying on a mode-less default; see `LgMappingTableObjectPagePage#refreshComponent`.
 */
@Component({
    selector: 'mvs-lg-logic-mapping-table-object-component',
    templateUrl: './lg-logic-mapping-table-object.component.html',
    standalone: false
})
export class LgLogicMappingTableObjectComponent extends ObjectBaseComponent
    implements OnInit, OnChanges, OnDestroy {

    override dto: LogicMappingTableDto;

    constructor(
        protected override coreService: MvsCoreService,
        protected override messageService: MvsMessageService,
        protected override confirmationService: ConfirmationService,
        protected override observerService: ObserverService) {
        super(coreService, messageService, confirmationService, observerService);
    }

    /**
     * Publishes the table name as the page/tab title once the object is loaded.
     */
    override onObjectChanged(): void {
        if (this.dto?.name) {
            this.setPageTitle(this.dto.name);
        }
    }

}
